import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aktionen',
  templateUrl: './aktionen.component.html',
  styleUrls: ['./aktionen.component.scss']
})
export class AktionenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
